module.exports = __webpack_public_path__ + "static/media/golnaz.11807fef.jpeg";